/*
 * Copyright (c) 2023. American Express Company
 */

// third-party
import React from 'react';
import { ButtonSecondary, CardRounded } from '@americanexpress/dls-react';

// models and services
import { CardStyleType } from 'src/types/card-type.enum';
import LiteralsService from 'src/services/literals/LiteralsService';
import { SelectCardViewModel } from 'src/types/view-models/select-card.view.model';

// components
import Typography from 'src/components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';

// icons and styles
import styles from './SelectCard.module.scss';
import Selectors from 'src/utils/selectors';

export default function SelectCard({ title, description, icon, onClick }: SelectCardViewModel): JSX.Element {
    return (
        <CardRounded type={CardStyleType.STANDARD}>
            <div className={styles.contentCard}>
                <div className={styles.iconContainer}>{icon}</div>
                <div className={styles.titleDescription}>
                    <Typography variant={TypographyVariants.SUBTEXT_BOLD}>{title}</Typography>
                    <Typography variant={TypographyVariants.SUBTEXT} className={styles.description}>
                        {description}
                    </Typography>
                </div>
                <ButtonSecondary
                    className={styles.selectButton}
                    onClick={onClick}
                    data-cy={Selectors.General.SELECT_CARD_BUTTON}
                >
                    {LiteralsService.getLiteral('SelectCard.selectButton')}
                </ButtonSecondary>
            </div>
        </CardRounded>
    );
}
